/* eslint-disable */
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import jim from "../images/philantrophy-slider/jim.jpg";

/**
 * This function renders the CEO Interview page
 * @component CEOInterview
 * @return {Component} CEOInterview component
 */
export default function CEOInterview() {
  return (
    <Card
      style={{
        width: '60%',
        margin: '40px auto',
        padding: '50px',
      }}
    >
      <Grid>
        <Typography variant="h6" gutterBottom>
          <h1>
            Interview with Jim D. Ray, Jr., Founder & CEO of Advanced
            Intelligence Services Corp.
          </h1>
        </Typography>
        <br />
        <div style={{ fontSize: '16px', lineHeight: '24px' }}>
          <p>
            Since high school graduation, CEO and biotechnologist Jim D. Ray,
            Jr. has appealed to Americans worldwide in the fight for small
            business development, community maximization, and even stage
            performance. But his latest endeavor is sure to get the quick
            attention of the international science community.
          </p>
          <p>
            Ray, now 41, leads the Advanced Intelligence Services Corporation, a
            biological and artificial intelligence research firm based near
            Chicago. Ray hopes to expand AIS Corp. into a permanent space-based
            corporation, defeating the limitations of Earth and preparing
            employees to face the realities of a new frontier attracting the
            world's richest CEOs.
          </p>
          <p>
            “Advanced Intelligence Services has the potential to go above and
            beyond the boundaries of Earth to achieve a new definition of
            corporate success," said Ray. "We're mapping out our objectives with
            the end in mind.”
          </p>
          <p>
            Ray is a 4.00 core-G.P.A. college student, and a former professional
            entertainer -- but there's no clowning around in space, or in the
            preparation to get there, he said.
          </p>
          <p>
            “AIS brings a unique approach to the Defense Department's goals,
            objectives, and tasks for space exploration and long-term
            operations, including colonization," said Ray. "We're working on
            multi-circa relations with the United States government to achive
            informational dominance in the race against time to claim a
            frontrunner status in, and beyond local space.”
          </p>
          <p>
            'Multi-circa' means Advanced Intelligence Services is efforting to
            cross-reference hard data between multiple generations of the U.S.
            government -- a common practice in written contracts -- for the
            purpose of discovering solutions and bringing resources together
            using a special technology called "meta," or Metabolic Physics Human
            Interface Devices (MPHIDs), emerging as a staple tech for military
            science personnel worldwide. But the private sector has it's eyes
            set on MPHIDs, too -- and Ray says it is only a matter of time
            before the commercial sector realizes the technology with, or
            without the experience-based education resulting from current-circa
            experimental use.
          </p>
          <p>
            “Most professionals are estimating meta tech will reach the public
            sector within five to seven years," said Ray. "I attest it could be
            much sooner, given the potential of hardware leaks into the civilian
            sector.”
          </p>
          <p>
            Ray's multi-circa method is one of many next-gen solutions AIS is
            predicting to deliver this year in the effort to overcome America's
            toughest challenges, a hope that could include improved relations
            with global partners and bring unity through the advancement of
            staple communications technologies, designed to avert war through
            information.
          </p>
          <p>
            To learn more about the Advanced Intelligence Services Corporation,
            employment opportunities, or current events at AIS, visit
            http://www.aisincorporated.com or e-mail
            services@aisincorporated.com.
          </p>
          <img src={jim}></img>
        </div>
      </Grid>
    </Card>
  );
}
